export default "__VITE_ASSET__DtnR4wvr__"